import GeneralUtils from './GeneralUtils.js'
import WidgetUtils from './WidgetUtils.js'
import axios from 'axios'
import TemplateUtils from './templates/TemplateUtils.js'
function loadSections (onSuccess, onError) {
  GeneralUtils.getBaseURL()
  axios.get(GeneralUtils.getBaseURL() + 'static/data/content.jsonn?version=' + GeneralUtils.getAppVersion()).then((response) => {
    onSuccess(response.data)
  }).catch((e) => {
    onError(e)
  })
}
function applyMobileProps(section){
  for (let i = 0; i < section.widgets.length; i++) {
    section.widgets[i].properties.mwidth = section.widgets[i].properties.width
    section.widgets[i].properties.mheight = section.widgets[i].properties.height
    section.widgets[i].properties.mleft = section.widgets[i].properties.left
    section.widgets[i].properties.mtop = section.widgets[i].properties.top
    if (section.widgets[i].properties.size) {
      section.widgets[i].properties.msize = section.widgets[i].properties.size
    }
    
    if (section.widgets[i].properties.modal === undefined || section.widgets[i].properties.modal === null) {
      section.widgets[i].properties.modal = ''
    }
    if (section.widgets[i].properties.link === undefined || section.widgets[i].properties.link === null) {
      section.widgets[i].properties.link = ''
    }
    if (section.widgets[i].type === WidgetUtils.WidgetTypes.IMAGE) {
      if (section.widgets[i].properties.alt === undefined || section.widgets[i].properties.alt === null) {
        section.widgets[i].properties.alt = ''
      }
    }
    if (section.widgets[i].type === WidgetUtils.WidgetTypes.TEXT) {
      if (section.widgets[i].properties.role === undefined || section.widgets[i].properties.role === null) {
        section.widgets[i].properties.role = ''
      }
    }
  }
  return section
}
function processSection (section, prepath) {
  section = applyMobileProps(section)
  let vadd = 0
  if (!section.processed) {
    section.background.image.url = prepath + section.background.image.url
    for (var i = 0; i < section.widgets.length; i++) {
      console.log(vadd)
      if (section.widgets[i].type === 'image') {
        section.widgets[i].properties.src = prepath + section.widgets[i].properties.src
      }
      section.widgets[i].properties.top = Number(section.widgets[i].properties.top) + vadd
      section.widgets[i].properties.mtop = Number(section.widgets[i].properties.mtop) + vadd
      if (section.widgets[i].vadd !== undefined) {
        vadd = section.widgets[i].vadd
      }
    }
    section.processed = true
  }
  return section
}
function inFrame (){
  let insideIframe = 'false'
  if (document.location.href.split('inframe=').length > 1) {
    insideIframe = document.location.href.split('inframe=')[1].split('&')[0]
  }
  return insideIframe.toLowerCase() === 'true'
}
function shouldStack (){
  let stack = 'false'
  if (document.location.href.split('stack=').length > 1) {
    stack = document.location.href.split('stack=')[1].split('&')[0]
  }
  return stack.toLowerCase() === 'true'
}
function mobileAlternate (){
  let ma = 'false'
  if (document.location.href.split('ma=').length > 1) {
    ma = document.location.href.split('ma=')[1].split('&')[0]
  }
  return ma.toLowerCase() === 'true' || getSite() == 'landing' || getSite() == 'casestudy'
}
function getWave(){
  let waveName = document.querySelector('#applicationversion').innerHTML.split('.')[0]
  if (document.location.href.split('wave=').length > 1) {
    waveName = document.location.href.split('wave=')[1].split('&')[0]
  }
  return waveName
}
function getSite(){
  let siteName = ''
  if (document.location.href.split('site=').length > 1) {
    siteName = document.location.href.split('site=')[1].split('&')[0]
  }
  return siteName
}
function getSectionList (onSuccess, onError) {
  let targetSite = getSite()
  let siteAddon = GeneralUtils.isMobile() && mobileAlternate() ? '_m' : ''
  let targetSections = targetSite === '' ? 'sections' + getWave() : targetSite + siteAddon
  axios.get(GeneralUtils.getBaseURL() + 'static/images/' + targetSections + '.txt?version=' + GeneralUtils.getAppVersion()).then((response) => {
    onSuccess(response.data.split(','))
  }).catch((e) => {
    onError(e)
  })
}
function getSectionsByList (list, onSuccess, onError, _sectionData, _index) {
  if (list.length > 0) {
    var index = _index || 0
    // console.log(list[index])
    var sectionData = _sectionData || []
    GeneralUtils.getBaseURL()
    axios.get(GeneralUtils.getBaseURL() + 'static/images/' + list[index] + '/content.json?version=' + GeneralUtils.getAppVersion()).then((response) => {
      // console.log(index)
      // console.log(response.data)
      sectionData.push(processSection(response.data, GeneralUtils.getBaseURL() + 'static/images/'))
      if (index === list.length - 1) {
        var sections = []
        for (var i = 0; i < sectionData.length; i++) {
          if (!sectionData[i].shared) {
            sections.push(sectionData[i])
          }
        }
        for (i = 0; i < sectionData.length; i++) {
          if (sectionData[i].shared) {
            sections.push(sectionData[i])
          }
        }
        onSuccess(sections)
      } else {
        getSectionsByList(list, onSuccess, onError, sectionData, index + 1)
      }
    }).catch((e) => {
      onError(e)
    })
  } else {
    onSuccess([])
  }
}
function addSectionToList (id, index, onSuccess, onError) {
  // console.log('INDEX TO INSERT: ' + index.toString())
  axios.post(GeneralUtils.getBaseURL() + 'editor/add_section', {id: id, index: index}).then((response) => {
    onSuccess(response.data)
  }).catch((_err) => {
    onError(_err)
  })
}
function addSection (id, section, index, onSuccess, onError) {
  saveSection(
    section,
    id,
    (d) => {
      addSectionToList(id, index, onSuccess, onError)
      // axios.post(GeneralUtils.getBaseURL() + 'editor/add_section', {id: id}).then((response) => {
      //   onSuccess(response.data)
      // }).catch((_err) => {
      //   onError(_err)
      // })
    },
    (err) => {
      onError(err)
    }
  )
}
function removeSection (id, onSuccess, onError) {
  axios.post(GeneralUtils.getBaseURL() + 'editor/remove_section', {id: id}).then((response) => {
    onSuccess(response.data)
  }).catch((_err) => {
    onError(_err)
  })
}
function arangeSections (sections, onSuccess, onError) {
  axios.post(GeneralUtils.getBaseURL() + 'editor/arange_sections', {sections: sections.join(',')}).then((response) => {
    onSuccess(response.data)
  }).catch((_err) => {
    onError(_err)
  })
}
function saveSection (section, dir, onSuccess, onError) {
  var postData = {section: JSON.stringify(section), dir: dir}
  // console.log(postData)
  axios.post(GeneralUtils.getBaseURL() + 'editor/save_section', postData).then((response) => {
    onSuccess(response.data)
  }).catch((e) => {
    onError(e)
  })
}
function getAllSlideFolders (onSuccess, onError) {
  axios.get(GeneralUtils.getBaseURL() + 'editor/get_slide_folders').then((response) => {
    onSuccess(response.data)
  }).catch((e) => {
    onError(e)
  })
}
function saveSharedSections (sections, dirs, onSuccess, onError) {
  var results = []
  var errors = []
  for (var i = 0; i < sections.length; i++) {
    if (sections[i].shared) {
      saveSection(
        sections[i],
        dirs[i],
        (d) => {
          results.push(d)
        },
        (err) => {
          errors.push(err)
          // console.log(err)
        }
      )
    }
  }
  if (results.length < 1) {
    onSuccess(results)
  }
  if (errors.length < 1) {
    onError(errors)
  }
}
function matchShartedTransitionCount (widget, count, index) {
  // console.log(widget)
  if (widget.transition.length < count) {
    var spliceIndex = index > count - 1 ? count - 1 : index
    widget.transition.splice(spliceIndex, 1)
    // if (widget.transition.length < count) {
    //   matchShartedTransitionCount(widget, count, index)
    // }
  } else if (widget.transition.length > count) {
    if (widget.transition[0]) {
      widget.transition.push(JSON.parse(JSON.stringify(widget.transition[0])))
    } else {
      widget.transition.push(JSON.parse(JSON.stringify(TemplateUtils.getTransition())))
    }
    // if (widget.transition.length > count) {
    //   matchShartedTransitionCount(widget, count, index)
    // }
  }
}
function getNonSharedSections (sections) {
  var nonShared = []
  for (var i = 0; i < sections.length; i++) {
    if (!sections[i].shared) {
      nonShared.push(sections[i])
    }
  }
  return nonShared
}
function remapSharedSections (sections, index) {
  var nonSharedTotal = getNonSharedSections(sections).length
  // for (var i = 0; i < sections.length; i++) {
  //   if (!sections[i].shared) {
  //     nonSharedTotal++
  //   }
  // }
  var total = index !== undefined && index !== undefined ? nonSharedTotal + 1 : nonSharedTotal - 1
  for (var j = 0; j < sections.length; j++) {
    if (sections[j].shared) {
      for (var w = 0; w < sections[j].widgets.length; w++) {
        matchShartedTransitionCount(sections[j].widgets[w], total, index)
      }
    }
  }
}
const Sections = {
  loadSections: loadSections,
  getSectionsByList: getSectionsByList,
  saveSection: saveSection,
  getSectionList: getSectionList,
  addSection: addSection,
  removeSection: removeSection,
  getAllSlideFolders: getAllSlideFolders,
  addSectionToList: addSectionToList,
  arangeSections: arangeSections,
  saveSharedSections: saveSharedSections,
  remapSharedSections: remapSharedSections,
  getNonSharedSections: getNonSharedSections,
  getWave: getWave,
  getSite: getSite,
  inFrame: inFrame,
  shouldStack: shouldStack,
  mobileAlternate: mobileAlternate
}
export default Sections



// WEBPACK FOOTER //
// ./src/components/utils/Sections.js